import { render, staticRenderFns } from "./applyCollection.vue?vue&type=template&id=c3294adc&"
import script from "./applyCollection.vue?vue&type=script&lang=js&"
export * from "./applyCollection.vue?vue&type=script&lang=js&"
import style0 from "./applyCollection.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./applyCollection.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports